var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgArrowTrendingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.71967 5.22211C2.01256 4.92922 2.48744 4.92922 2.78033 5.22211L7.5 9.94178L11.2685 6.17329C11.4187 6.02306 11.6256 5.94359 11.8378 5.95463C12.05 5.96568 12.2475 6.06619 12.3813 6.23121C14.0732 8.31739 15.388 10.7612 16.1939 13.4849L17.7685 10.7576C17.9756 10.3989 18.4343 10.276 18.793 10.4831C19.1517 10.6902 19.2747 11.1489 19.0675 11.5076L16.5927 15.7942C16.3856 16.153 15.9269 16.2759 15.5682 16.0688L11.2815 13.5939C10.9228 13.3868 10.7999 12.9281 11.007 12.5694C11.2141 12.2106 11.6728 12.0877 12.0315 12.2949L14.7401 13.8586C14.0741 11.6301 13.0419 9.60646 11.7278 7.83529L8.03033 11.5328C7.88968 11.6734 7.69891 11.7524 7.5 11.7524C7.30109 11.7524 7.11032 11.6734 6.96967 11.5328L1.71967 6.28277C1.42678 5.98988 1.42678 5.515 1.71967 5.22211Z",
    fill: "#EA2727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgArrowTrendingDown);
export default __webpack_public_path__ + "static/media/svg_arrow_trending_down.6c5e6a568bdf740b5f3bdb5770f34275.svg";
export { ForwardRef as ReactComponent };